export const SET_HRES78U_INDEX_DISP = 'SET_HRES78U_INDEX_DISP'
export const GET_HRES78U_INDEX_DISP = 'GET_HRES78U_INDEX_DISP'
export const SET_HRES78U_DETAIL_DISP = 'SET_HRES78U_DETAIL_DISP'
export const GET_HRES78U_DETAIL_DISP = 'GET_HRES78U_DETAIL_DISP'
export const SET_HRES78U_MAX_ROWSPAN = 'SET_HRES78U_MAX_ROWSPAN'
export const GET_HRES78U_MAX_ROWSPAN = 'GET_HRES78U_MAX_ROWSPAN'
export const SET_HRES78U_COLUMNS = 'SET_HRES78U_COLUMNS'
export const GET_HRES78U_COLUMNS = 'GET_HRES78U_COLUMNS'
export const SET_HRES78U_LABELS = 'SET_HRES78U_LABELS'
export const GET_HRES78U_LABELS = 'GET_HRES78U_LABELS'
export const RECEIVED_HRES78U_COLUMNS_LABELS = 'RECEIVED_HRES78U_COLUMNS_LABELS'
export const SET_HRES78U_INDEX = 'SET_HRES78U_INDEX'
export const GET_HRES78U_INDEX = 'GET_HRES78U_INDEX'
export const RECEIVED_HRES78U_INDEX = 'RECEIVED_HRES78U_INDEX'
export const SET_HRES78U_INDEX_SELECTED = 'SET_HRES78U_INDEX_SELECTED'
export const GET_HRES78U_INDEX_SELECTED = 'GET_HRES78U_INDEX_SELECTED'

export const SET_HRES78U_DETAIL = 'SET_HRES78U_DETAIL'
export const GET_HRES78U_DETAIL = 'GET_HRES78U_DETAIL'
export const RECEIVED_HRES78U_DETAIL = 'RECEIVED_HRES78U_DETAIL'

export const SET_HRES78U_DETAIL_SUBMIT = 'SET_HRES78U_DETAIL_SUBMIT'
export const GET_HRES78U_DETAIL_SUBMIT = 'GET_HRES78U_DETAIL_SUBMIT'
export const RECEIVED_HRES78U_DETAIL_SUBMIT = 'RECEIVED_HRES78U_DETAIL_SUBMIT'

export const TOGGLE_HRES78U_PAGE = 'TOGGLE_HRES78U_PAGE'
export const POST_HRES78U_SEND_APPROVE = 'POST_HRES78U_SEND_APPROVE'
export const RECEIVED_HRES78U_DROPDOWNS = 'RECEIVED_HRES78U_DROPDOWNS'
export const SET_HRES78U_DROPDOWNS = 'SET_HRES78U_DROPDOWNS'
export const GET_HRES78U_DROPDOWNS = 'GET_HRES78U_DROPDOWNS'

export const RECEIVED_HRES78U_POPUP_PROCESSTABLE = 'RECEIVED_HRES78U_POPUP_PROCESSTABLE'
export const SET_HRES78U_POPUP_PROCESSTABLE = 'SET_HRES78U_POPUP_PROCESSTABLE'
export const GET_HRES78U_POPUP_PROCESSTABLE = 'GET_HRES78U_POPUP_PROCESSTABLE'
export const GET_HRES78U_SHOW_PROCESSTABLE = 'GET_HRES78U_SHOW_PROCESSTABLE'
export const SET_HRES78U_SHOW_PROCESSTABLE = 'SET_HRES78U_SHOW_PROCESSTABLE'

export const RECEIVED_HRES78U_POPUP_TRAILREPAYMENT = 'RECEIVED_HRES78U_POPUP_TRAILREPAYMENT'
export const SET_HRES78U_POPUP_TRAILREPAYMENT = 'SET_HRES78U_POPUP_TRAILREPAYMENT'
export const GET_HRES78U_POPUP_TRAILREPAYMENT = 'GET_HRES78U_POPUP_TRAILREPAYMENT'
export const GET_HRES78U_SHOW_TRAILREPAYMENT = 'GET_HRES78U_SHOW_TRAILREPAYMENT'
export const SET_HRES78U_SHOW_TRAILREPAYMENT = 'SET_HRES78U_SHOW_TRAILREPAYMENT'

export const RECEIVED_HRES78U_POPUP_PERSONALDATA = 'RECEIVED_HRES78U_POPUP_PERSONALDATA'
export const SET_HRES78U_POPUP_PERSONALDATA = 'SET_HRES78U_POPUP_PERSONALDATA'
export const GET_HRES78U_POPUP_PERSONALDATA = 'GET_HRES78U_POPUP_PERSONALDATA'
export const SET_HRES78U_SHOW_PERSONALDATA = 'SET_HRES78U_SHOW_PERSONALDATA'
export const GET_HRES78U_SHOW_PERSONALDATA = 'GET_HRES78U_SHOW_PERSONALDATA'



// WEBPACK FOOTER //
// ./src/store/modules/hres78u/mutation-types.js